import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, getContatById, valuesAnalyze, changeViewForms, createPhone, updateContact, deletePhone, deleteContact, updatePhone, clickToCall } from '../../services';

import Loading from '../../components/Loading/LoadingModule';
import PhoneCard from './PhoneListShowCard';
import InputSetPhone from './PhoneCreate';
import InputEditPhone from './PhoneEdit';

import '../../libs/bulma.min.css';
import './ContactsShow.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

function ShowContacts() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit, toggleIsHidden, toggleIsChangeFormElements, itemsSelectedToEdit, } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [ph, setPh] = useState([]);
  const [disable, setDisable] = useState(true);
  const [phoneModify, setPhoneModify] = useState({});
  const [inputPhone, setInputPhone] = useState({});
  const [idModPhone, setIidModPhone] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    const contactFetch = await getContatById({ id: itemsSelectedToEdit });
    if(itemsSelectedToEdit.length <= 0) return history.push('/agenda/lista');
    if(contactFetch === undefined) setLoading(true);
    if(contactFetch['phones'].length > 0) setPh(contactFetch['phones']);
    setValues(contactFetch);
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj' || name === 'numberphone' || name === 'editnumberphone') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'company' || name === 'addr') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const insertNumberPhone = () => {
    changeVisibityMessages(true, 'buttons-edit-contact');
    changeVisibityMessages(true, 'list-phones');
    changeVisibityMessages(false, 'input-phone');
  };

  const handleChangeInput = (item) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setInputPhone({ number: Number(value), contactid: values['idcont'] })
  };

  const handleChangeInputPhoneEdit = (item, idPhone) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setPhoneModify({ phone: Number(value), id: idModPhone })
  };

  const saveNewPhone = async () => {
    try {
      const newPhone = await createPhone(inputPhone);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
  
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const cancelCreatePhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const saveEditedPhone = async () => {
    const newPhone = await updatePhone(phoneModify);
    setItemsSelectedToEdit(phoneModify);
    await validateUserLogged();

    changeVisibityMessages(false, 'buttons-edit-contact');
    changeVisibityMessages(false, 'list-phones');
    changeVisibityMessages(true, 'input-edit-phone');
  };

  const cancelEditedPhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-edit-phone');
    } catch (error) {
      console.log(error)
    }
  };

  const handleClickDelete = async () => {
    try {
      const sendDeleteContact = await deleteContact({ id: values['idcont'] });
      toggleIsHidden('#update-form');
      // toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#success-deleted-contacts');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    } catch (error) {
      toggleIsHidden('#update-form');
      toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#error-delete-contact');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/home');
      }, 3000);
    }
  };

  const handleClickDeletePhone = async (data) => {
    const { value, phone } = data;
    try {
      const sendDeleteContact = await deletePhone({ id: Number(value) });
      if(values['phones'].length === 1) history.push('/agenda/lista');
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
    } catch (error) {
      changeVisibityMessages(false, `delete-phone-link-${value}`);
      changeVisibityMessages(true, `delete-phone-confirm-${value}`);
    }

  };
  
  const sendDataContactUpdate = async () => {
    const updateContactSend = await updateContact({
      id: values['idcont'],
      company: values['compname'],
      fantasy: values['namefantasy'],
      addr: values['addr'],
      cnpj: Number(values['cnpj']),
      email: values['mail'],
      alias: values['alias'],
      comment: values['comm'],
    });

    const result = Object.keys(updateContactSend).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
      changeVisibityMessages(false, 'success-updeted-contacts');
      setTimeout(() => {
        return changeVisibityMessages(true, 'success-updeted-contacts');
      }, 3000);
    };
    return;
  };

  
  const handleClickToCall = async (phone) => {
    let phoneFull = phone;
    if(phoneFull.length === 10 || phoneFull.length === 11) phoneFull = `0${phone}`;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = { 
      name: `${values['namefantasy']}`,
      dest: phoneFull,
      exten: user.endpoint
    }
    console.log(myEndpoint);
    const result = await clickToCall(myEndpoint);
  };

  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="contacts-show-container">
      {loading ? (
        <Loading />
      ) : (
        <>
            <div className="contacts-show-header">
              <div className="contacts-show-title-wrapper">
                <svg className="contacts-show-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <div>
                  <h1 className="contacts-show-title">Visualizar Contato</h1>
                  <p className="contacts-show-subtitle">Informações do contato</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button className="btn-edit-contact" onClick={() => history.push('/agenda/contato/id')}>
                  <FontAwesomeIcon icon={faSave} />
                  Editar
                </button>
                <Link to="/agenda/lista" className="btn-back">
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Voltar
                </Link>
              </div>
            </div>
            <div className="contact-info-card">
              <div className="contact-info-grid">
                <div className="contact-info-item">
                  <span className="contact-info-label">Razão Social:</span>
                  <span className="contact-info-value">{ values['compname'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">CNPJ/CPF:</span>
                  <span className="contact-info-value">{ values['cnpj'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Nome Fantasia:</span>
                  <span className="contact-info-value">{ values['namefantasy'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">E-mail:</span>
                  <span className="contact-info-value">{ values['mail'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Endereço:</span>
                  <span className="contact-info-value">{ values['addr'] }</span>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-label">Apelido:</span>
                  <span className="contact-info-value">{ values['alias'] }</span>
                </div>
                <div className="contact-info-item contact-info-item-full">
                  <span className="contact-info-label">Comentários:</span>
                  <span className="contact-info-value">{ values['comm'] }</span>
                </div>
              </div>
            </div>
            <div id="list-phones" name="list-phones" className="phones-grid-show">
              { ph.map((phone) => <PhoneCard key={phone.phonenumber} phones={ phone } changeVisibityMessages={ changeVisibityMessages } handleClickToCall={ handleClickToCall } setPhoneModify={ setPhoneModify } setIidModPhone={ setIidModPhone } del={ handleClickDeletePhone }/>) }
            </div>
        </>
      )}
    </div>
  );
}

export default ShowContacts;
